import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter {
    isMultiError: boolean;
}

type HandlerType = CustomHandler<Parameter>;

export const CenQtyMulti: HandlerType = props => {
    props.dispatch({
        type: "Pages/CenQtyMultiState",
        isMultiError: props.parameter.isMultiError,
    });
};

export const chain = [CenQtyMulti];

const cenQtyMulti = createHandlerChainRunner(chain, "CenQtyMulti");
export default cenQtyMulti;
